import { DB_NAME, STORED_VALUE_NAME } from '../constants';
import { createLogger } from "@sage/sbc.core.utils.ui";

export const deleteIndexDbKeys = (pattern) => {
    const logger = createLogger();
    try {
        const db = window.indexedDB.open(DB_NAME);

        db.onupgradeneeded = (event) => {
            const internalDb = event.target.result;

            // Create an object store if it does not exist
            if (!internalDb.objectStoreNames.contains(STORED_VALUE_NAME)) {
                internalDb.createObjectStore(STORED_VALUE_NAME);
            }
        };

        db.onsuccess = (event) => {
            const database = event.target.result;

            const transaction = database.transaction(
                STORED_VALUE_NAME,
                "readwrite"
            );
            const objectStore = transaction.objectStore(STORED_VALUE_NAME);

            // Open a cursor to iterate through all keys
            const request = objectStore.openCursor();

            request.onsuccess = (e) => {
                const cursor = e.target.result;

                if (cursor) {
                    // If the key contains the pattern, delete it
                    if (cursor.key.includes(pattern)) {
                        objectStore.delete(cursor.key);
                    }
                    // Move to the next key
                    cursor.continue();
                }
            };

            transaction.oncomplete = () => {
                logger.log(
                    `Keys containing "${pattern}" deleted successfully.`
                );
            };
        };
    } catch (error) {
        console.error(`General error: ${error}`);
    }
};